import React from 'react'
import {
  Container,
  Grid,
  Col,
  Text,
  Paper,
  List,
  ThemeIcon,
} from '@mantine/core'
import { CircleCheck } from 'tabler-icons-react'
import useTranslation from 'next-translate/useTranslation'

const ComplaintsAndSuggestions = () => {
  const { lang } = useTranslation()
  return (
    <>
      {lang === 'en' ? (
        <Container size="lg">
          <Grid>
            <Col span={12}>
              <>
                <Text size="lg" weight={700} style={{ marginBottom: '1rem' }}>
                  Complaints and Suggestions Mechanism
                </Text>
                <Text size="md" weight={500} style={{ marginBottom: '1rem' }}>
                  To ensure an effective mechanism for submitting complaints and
                  suggestions, the following points can be followed:
                </Text>
                <List
                  spacing="sm"
                  size="sm"
                  icon={
                    <ThemeIcon color="blue" size={24} radius="xl">
                      <CircleCheck size={16} />
                    </ThemeIcon>
                  }
                >
                  <List.Item>
                    <Text size="md" weight={500}>
                      Providing a “Contact Us” Form on the Website:
                    </Text>
                    <Text>
                      The form must contain fields for contact information (such
                      as name, email, and phone number). It must include fields
                      to specify the type of request (complaint, suggestion) and
                      subject details. Allows users to easily submit a request.
                    </Text>
                  </List.Item>
                  <List.Item>
                    <Text size="md" weight={500}>
                      Reply within 48 Hours:
                    </Text>
                    <Text>
                      The Academy is committed to responding to complaints and
                      suggestions within 48 hours via any available means of
                      communication.
                    </Text>
                  </List.Item>
                  <List.Item>
                    <Text size="md" weight={500}>
                      Submit the Application Easily and Quickly:
                    </Text>
                    <Text>
                      The Academy ensures that the process of registering or
                      submitting an application via the website does not take
                      more than 5 minutes.
                    </Text>
                  </List.Item>
                  <List.Item>
                    <Text size="md" weight={500}>
                      Contact Information is Available Upon Registration for
                      Each Training Activity:
                    </Text>
                    <Text>
                      Contact information is clearly provided when registering
                      for each training activity.
                    </Text>
                  </List.Item>
                  <List.Item>
                    <Text size="md" weight={500}>
                      Interaction via Social Media:
                    </Text>
                    <Text>
                      The Academy responds to trainees and practitioners via
                      social media platforms such as Twitter and Instagram.
                    </Text>
                  </List.Item>
                  <List.Item>
                    <Text size="md" weight={500}>
                      Constant Communication:
                    </Text>
                    <Text>Trainees can contact the center at any time.</Text>
                  </List.Item>
                  <List.Item>
                    <Text size="md" weight={500}>
                      Providing Social Media Accounts on the Website:
                    </Text>
                    <Text>
                      Links to the academy's official social media accounts are
                      provided on the website.
                    </Text>
                  </List.Item>
                  <List.Item>
                    <Text size="md" weight={500}>
                      Customer Service Around the Clock:
                    </Text>
                    <Text>
                      Providing customer service via email around the clock to
                      ensure a quick response to any inquiry or complaint.
                    </Text>
                  </List.Item>
                </List>
                <Text size="md" weight={500} style={{ marginTop: '1rem' }}>
                  Contact Information:
                </Text>
                <Text>Email: info@infinity.edu.sa</Text>
                <Text>Contact Number: +966564572240</Text>
                <Text>WhatsApp Chat: +966570322051</Text>
                <Text>
                  Center Headquarters/Site: Location: Jeddah, Kingdom of Saudi
                  Arabia, Al-Baghdadiyah district, intersection of Hail Road and
                  Crown Prince Road.
                </Text>
                <Text style={{ marginTop: '1rem' }}>
                  By applying these points, the Academy will be able to provide
                  excellent service to communicate with trainees and
                  practitioners and ensure a rapid response to their needs and
                  suggestions.
                </Text>
              </>
            </Col>
          </Grid>
        </Container>
      ) : (
        <Container size="lg">
          <Grid>
            <Col span={12}>
              <>
                <Text size="lg" weight={700} style={{ marginBottom: '1rem' }}>
                  آلية لرفع الشكاوى والمقترحات
                </Text>
                <Text size="md" weight={500} style={{ marginBottom: '1rem' }}>
                  لضمان توفير آلية فعالة لرفع الشكاوى والمقترحات، يمكن اتباع
                  النقاط التالية:
                </Text>
                <List
                  spacing="sm"
                  size="sm"
                  icon={
                    <ThemeIcon color="blue" size={24} radius="xl">
                      <CircleCheck size={16} />
                    </ThemeIcon>
                  }
                >
                  <List.Item>
                    <Text size="md" weight={500}>
                      توفير استمارة "اتصل بنا" على الموقع:
                    </Text>
                    <Text>
                      يجب أن تحتوي الاستمارة على حقول لبيانات التواصل (مثل
                      الاسم، البريد الإلكتروني، ورقم الهاتف). يجب أن تتضمن
                      حقولًا لتحديد نوع الطلب (شكوى، اقتراح) وتفاصيل الموضوع.
                      تتيح للمستخدمين إرسال الطلب بسهولة.
                    </Text>
                  </List.Item>
                  <List.Item>
                    <Text size="md" weight={500}>
                      الرد خلال 48 ساعة:
                    </Text>
                    <Text>
                      تلتزم الأكاديمية بالرد على الشكاوى والمقترحات خلال 48 ساعة
                      عبر أي وسيلة تواصل متاحة.
                    </Text>
                  </List.Item>
                  <List.Item>
                    <Text size="md" weight={500}>
                      تقديم الطلب بسهولة وسرعة:
                    </Text>
                    <Text>
                      تضمن الأكاديمية أن عملية تسجيل أو تقديم طلب عبر الموقع
                      الإلكتروني لا تستغرق أكثر من 5 دقائق.
                    </Text>
                  </List.Item>
                  <List.Item>
                    <Text size="md" weight={500}>
                      معلومات التواصل متاحة عند التسجيل لكل نشاط تدريبي:
                    </Text>
                    <Text>
                      يتم توفير معلومات التواصل بوضوح عند التسجيل لكل نشاط
                      تدريبي.
                    </Text>
                  </List.Item>
                  <List.Item>
                    <Text size="md" weight={500}>
                      التفاعل عبر وسائل التواصل الاجتماعي:
                    </Text>
                    <Text>
                      تتجاوب الأكاديمية مع المتدربين والممارسين عبر منصات
                      التواصل الاجتماعي مثل تويتر وإنستغرام.
                    </Text>
                  </List.Item>
                  <List.Item>
                    <Text size="md" weight={500}>
                      التواصل المستمر:
                    </Text>
                    <Text>يمكن للمتدربين التواصل مع المركز في أي وقت.</Text>
                  </List.Item>
                  <List.Item>
                    <Text size="md" weight={500}>
                      توفير حسابات التواصل الاجتماعي على الموقع:
                    </Text>
                    <Text>
                      يتم توفير روابط لحسابات التواصل الاجتماعي الرسمية
                      للأكاديمية على الموقع الإلكتروني.
                    </Text>
                  </List.Item>
                  <List.Item>
                    <Text size="md" weight={500}>
                      خدمة المتعاملين على مدار الساعة:
                    </Text>
                    <Text>
                      تقديم خدمة العملاء عبر البريد الإلكتروني على مدار الساعة
                      لضمان الرد السريع على أي استفسار أو شكوى.
                    </Text>
                  </List.Item>
                </List>
                <Text style={{ marginTop: '1rem' }}>
                  بتطبيق هذه النقاط، ستتمكن الأكاديمية من تقديم خدمة ممتازة
                  للتواصل مع المتدربين والممارسين وضمان الاستجابة السريعة
                  لاحتياجاتهم ومقترحاتهم.
                </Text>
              </>
            </Col>
          </Grid>
        </Container>
      )}
    </>
  )
}

export default ComplaintsAndSuggestions
